import { ConsultationRequestUserRelationDTO } from '@/generated'

type ConsultationWithRelation = {
  id: string
  relationToUser?: ConsultationRequestUserRelationDTO
}

export function isOwnConsultation(consultation: ConsultationWithRelation): boolean {
  return consultation.relationToUser !== ConsultationRequestUserRelationDTO.NONE
}

// The backend relation is per list: a consultation assigned to the chief and requested by a ward
// member is INCOMING in the incoming list but NONE in the outgoing one, so it is not supervised.
export function pickSupervisedConsultations<T extends ConsultationWithRelation>(
  incoming: T[],
  outgoing: T[]
): T[] {
  const consultations = [...incoming, ...outgoing]
  const ownIds = new Set(consultations.filter(isOwnConsultation).map(({ id }) => id))
  const supervisedById = new Map<string, T>()

  consultations
    .filter(({ id }) => !ownIds.has(id))
    .forEach((consultation) => {
      if (!supervisedById.has(consultation.id)) {
        supervisedById.set(consultation.id, consultation)
      }
    })

  return [...supervisedById.values()]
}
